import { Popconfirm } from 'antd';
import React, { forwardRef, useImperativeHandle, useRef, useEffect, useState } from 'react';
import { useAppDispatch, useAppSelector } from '../../../../store/app.hooks';
import _ from 'lodash';
import {
  FilterByDateSwap,
  FilterWithSwapOption,
} from '../../../../common/components/DataTable/DataTableFilters';
import { IMainTable } from '../../../../common/models/common';
import { ISearch } from '../../../../services/o365/o365-copilot-chat-usage/o365-copilot-chat-usage.model';
import { useHistory } from 'react-router-dom';
import DataTable from '../../../../common/components/DataTable';
import ability, { Can } from '../../../../common/ability';
import { Action, Page } from '../../../../common/constants/pageAction';
import {
  deleteO365CopilotChatUsage,
  searchO365CopilotChatUsage,
} from '../../../../store/o365/o365-copilot-chat-usage/o365-copilot-chat-usage.action';
import {
  clearO365CopilotChatUsageMessages,
  o365CopilotChatUsageSelector,
  setTableColumnSelection,
} from '../../../../store/o365/o365-copilot-chat-usage/o365-copilot-chat-usage.reducer';
import o365CopilotChatUsageService from '../../../../services/o365/o365-copilot-chat-usage/o365-copilot-chat-usage.service';
import { showDateFromApi } from '../../../../common/helperFunction';

const MainTable: React.ForwardRefRenderFunction<unknown, IMainTable> = (props, ref) => {
  const {
    setSelectedId,
    setShowSelectedListModal,
    setValuesForSelection,
    isMultiple,
    setFilterKeys,
    tableButtons,
  } = props;
  const o365CopilotChatUsage = useAppSelector(o365CopilotChatUsageSelector);
  const dispatch = useAppDispatch();
  const dataTableRef = useRef(null);
  const history = useHistory();
  const [ObjectForColumnFilter, setObjectForColumnFilter] = useState({});

  useImperativeHandle(ref, () => ({
    refreshData() {
      dataTableRef?.current.refreshData();
    },
  }));

  useEffect(() => {
    if (isMultiple) {
      dataTableRef?.current.getValuesForSelection();
    }
  }, [isMultiple]);

  const exportExcelFile = (searchData: ISearch) => {
    return o365CopilotChatUsageService.exportExcelFile(searchData);
  };

  const FilterBySwap = (dataIndex: string, form, isRelativeDropDownFlag?: boolean) => {
    setFilterKeys(ObjectForColumnFilter);
    return FilterWithSwapOption(
      dataIndex,
      o365CopilotChatUsage.search.tableName,
      form,
      null,
      ObjectForColumnFilter,
      null,
      null,
      isRelativeDropDownFlag
    );
  };

  const FilterByDateSwapTable = (dataIndex: string, tableName: string, form: any) => {
    return FilterByDateSwap(dataIndex, tableName, form, null, ObjectForColumnFilter);
  };

  const getTableColumns = (form) => {
    return [
      {
        title: <span className="dragHandler">ID</span>,
        column: 'id',
        sorter: true,
        ellipsis: true,
        children: [
          {
            title: FilterBySwap('id', form),
            dataIndex: 'id',
            key: 'id',
            ellipsis: true,
          },
        ],
      },
      {
        title: <span className="dragHandler">Tenant Name</span>,
        column: 'TenantId',
        sorter: true,
        children: [
          {
            title: FilterBySwap('tenant_id', form, true),
            dataIndex: 'tenant_name',
            key: 'tenant_name',
            ellipsis: true,
          },
        ],
      },
      {
        title: <span className="dragHandler">Company Name</span>,
        column: 'CompanyId',
        sorter: true,
        children: [
          {
            title: FilterBySwap('company_id', form, true),
            dataIndex: 'company_name',
            key: 'company_name',
            ellipsis: true,
          },
        ],
      },
      {
        title: <span className="dragHandler">BU Name</span>,
        column: 'BU_Id',
        sorter: true,
        children: [
          {
            title: FilterBySwap('bu_id', form, true),
            dataIndex: 'bu_name',
            key: 'bu_name',
            ellipsis: true,
          },
        ],
      },
      {
        title: <span className="dragHandler">Date Added</span>,
        column: 'Date Added',
        sorter: true,
        children: [
          {
            title: FilterByDateSwapTable('date_added', o365CopilotChatUsage.search.tableName, form),
            dataIndex: 'date_added',
            key: 'date_added',
            ellipsis: true,
            render: (date: Date) => (!_.isNull(date) ? showDateFromApi(date) : ''),
          },
        ],
      },
      {
        title: <span className="dragHandler">User Principal Name</span>,
        column: 'User Principal Name',
        sorter: true,
        children: [
          {
            title: FilterBySwap('user_principal_name', form),
            dataIndex: 'user_principal_name',
            key: 'user_principal_name',
            ellipsis: true,
          },
        ],
      },
      {
        title: <span className="dragHandler">Display Name</span>,
        column: 'Display Name',
        sorter: true,
        children: [
          {
            title: FilterBySwap('display_name', form),
            dataIndex: 'display_name',
            key: 'display_name',
            ellipsis: true,
          },
        ],
      },
      {
        title: <span className="dragHandler">Report Period</span>,
        column: 'Report Period',
        sorter: true,
        children: [
          {
            title: FilterBySwap('report_period', form),
            dataIndex: 'report_period',
            key: 'report_period',
            ellipsis: true,
          },
        ],
      },
      {
        title: <span className="dragHandler">Prompts Submitted</span>,
        column: 'Prompts Submitted',
        sorter: true,
        children: [
          {
            title: FilterBySwap('prompts_submitted', form),
            dataIndex: 'prompts_submitted',
            key: 'prompts_submitted',
            ellipsis: true,
          },
        ],
      },
      {
        title: <span className="dragHandler">Active Usage Days</span>,
        column: 'Active Usage Days',
        sorter: true,
        children: [
          {
            title: FilterBySwap('active_usage_days', form),
            dataIndex: 'active_usage_days',
            key: 'active_usage_days',
            ellipsis: true,
          },
        ],
      },
      {
        title: <span className="dragHandler">Last Activity Date</span>,
        column: 'Last Activity Date',
        sorter: true,
        children: [
          {
            title: FilterByDateSwap(
              'last_activity_date',
              o365CopilotChatUsage.search.tableName,
              form,
              null,
              ObjectForColumnFilter
            ),
            dataIndex: 'last_activity_date',
            key: 'last_activity_date',
            ellipsis: true,
            render: (date: Date) => (!_.isNull(date) ? showDateFromApi(date) : ''),
          },
        ],
      },
      {
        title: <span className="dragHandler">Last Activity (Teams)</span>,
        column: 'Last Activity (Teams)',
        sorter: true,
        children: [
          {
            title: FilterByDateSwap(
              'last_activity_date_of_teams_utc',
              o365CopilotChatUsage.search.tableName,
              form,
              null,
              ObjectForColumnFilter
            ),
            dataIndex: 'last_activity_date_of_teams_utc',
            key: 'last_activity_date_of_teams_utc',
            ellipsis: true,
            render: (date: Date) => (!_.isNull(date) ? showDateFromApi(date) : ''),
          },
        ],
      },
      {
        title: <span className="dragHandler">Last Activity (Word)</span>,
        column: 'Last Activity (Word)',
        sorter: true,
        children: [
          {
            title: FilterByDateSwap(
              'last_activity_date_of_word_utc',
              o365CopilotChatUsage.search.tableName,
              form,
              null,
              ObjectForColumnFilter
            ),
            dataIndex: 'last_activity_date_of_word_utc',
            key: 'last_activity_date_of_word_utc',
            ellipsis: true,
            render: (date: Date) => (!_.isNull(date) ? showDateFromApi(date) : ''),
          },
        ],
      },
      {
        title: <span className="dragHandler">Last Activity (Excel)</span>,
        column: 'Last Activity (Excel)',
        sorter: true,
        children: [
          {
            title: FilterByDateSwap(
              'last_activity_date_of_excel_utc',
              o365CopilotChatUsage.search.tableName,
              form,
              null,
              ObjectForColumnFilter
            ),
            dataIndex: 'last_activity_date_of_excel_utc',
            key: 'last_activity_date_of_excel_utc',
            ellipsis: true,
            render: (date: Date) => (!_.isNull(date) ? showDateFromApi(date) : ''),
          },
        ],
      },
      {
        title: <span className="dragHandler">Last Activity (PowerPoint)</span>,
        column: 'Last Activity (PowerPoint)',
        sorter: true,
        children: [
          {
            title: FilterByDateSwap(
              'last_activity_date_of_powerpoint_utc',
              o365CopilotChatUsage.search.tableName,
              form,
              null,
              ObjectForColumnFilter
            ),
            dataIndex: 'last_activity_date_of_powerpoint_utc',
            key: 'last_activity_date_of_powerpoint_utc',
            ellipsis: true,
            render: (date: Date) => (!_.isNull(date) ? showDateFromApi(date) : ''),
          },
        ],
      },
      {
        title: <span className="dragHandler">Last Activity (Outlook)</span>,
        column: 'Last Activity (Outlook)',
        sorter: true,
        children: [
          {
            title: FilterByDateSwap(
              'last_activity_date_of_outlook_utc',
              o365CopilotChatUsage.search.tableName,
              form,
              null,
              ObjectForColumnFilter
            ),
            dataIndex: 'last_activity_date_of_outlook_utc',
            key: 'last_activity_date_of_outlook_utc',
            ellipsis: true,
            render: (date: Date) => (!_.isNull(date) ? showDateFromApi(date) : ''),
          },
        ],
      },
      {
        title: <span className="dragHandler">Last Activity (OneNote)</span>,
        column: 'Last Activity (OneNote)',
        sorter: true,
        children: [
          {
            title: FilterByDateSwap(
              'last_activity_date_of_onenote_utc',
              o365CopilotChatUsage.search.tableName,
              form,
              null,
              ObjectForColumnFilter
            ),
            dataIndex: 'last_activity_date_of_onenote_utc',
            key: 'last_activity_date_of_onenote_utc',
            ellipsis: true,
            render: (date: Date) => (!_.isNull(date) ? showDateFromApi(date) : ''),
          },
        ],
      },
      {
        title: <span className="dragHandler">Last Activity (M365 Copilot App)</span>,
        column: 'Last Activity (M365 Copilot App)',
        sorter: true,
        children: [
          {
            title: FilterByDateSwap(
              'last_activity_date_of_microsoft_365_copilot_app_utc',
              o365CopilotChatUsage.search.tableName,
              form,
              null,
              ObjectForColumnFilter
            ),
            dataIndex: 'last_activity_date_of_microsoft_365_copilot_app_utc',
            key: 'last_activity_date_of_microsoft_365_copilot_app_utc',
            ellipsis: true,
            render: (date: Date) => (!_.isNull(date) ? showDateFromApi(date) : ''),
          },
        ],
      },
      {
        title: <span className="dragHandler">Last Activity (Edge)</span>,
        column: 'Last Activity (Edge)',
        sorter: true,
        children: [
          {
            title: FilterByDateSwap(
              'last_activity_date_of_edge_utc',
              o365CopilotChatUsage.search.tableName,
              form,
              null,
              ObjectForColumnFilter
            ),
            dataIndex: 'last_activity_date_of_edge_utc',
            key: 'last_activity_date_of_edge_utc',
            ellipsis: true,
            render: (date: Date) => (!_.isNull(date) ? showDateFromApi(date) : ''),
          },
        ],
      },
      {
        title: <span className="dragHandler">Last Activity (Copilot.cloud.microsoft)</span>,
        column: 'Last Activity (Copilot.cloud.microsoft)',
        sorter: true,
        children: [
          {
            title: FilterByDateSwap(
              'last_activity_date_of_copilot_cloud_microsoft_utc',
              o365CopilotChatUsage.search.tableName,
              form,
              null,
              ObjectForColumnFilter
            ),
            dataIndex: 'last_activity_date_of_copilot_cloud_microsoft_utc',
            key: 'last_activity_date_of_copilot_cloud_microsoft_utc',
            ellipsis: true,
            render: (date: Date) => (!_.isNull(date) ? showDateFromApi(date) : ''),
          },
        ],
      },
    ];
  };

  const removeO365CopilotChatUsage = (id: number) => {
    dispatch(deleteO365CopilotChatUsage(id));
  };

  const tableAction = (_, data: any) => (
    <div className="btns-block">
      <Can I={Action.Update} a={Page.O365CopilotChatUsage}>
        <a
          className="action-btn"
          onClick={() => {
            setSelectedId(data.id);
            history.push(`/o365/o365-copilot-chat-usage/${data.id}`);
          }}
        >
          <img src={`${process.env.PUBLIC_URL}/assets/images/ic-edit.svg`} alt="" />
        </a>
      </Can>
      <Can I={Action.Delete} a={Page.O365CopilotChatUsage}>
        <Popconfirm title="Delete Record?" onConfirm={() => removeO365CopilotChatUsage(data.id)}>
          <a href="#" title="" className="action-btn">
            <img src={`${process.env.PUBLIC_URL}/assets/images/ic-delete.svg`} alt="" />
          </a>
        </Popconfirm>
      </Can>
    </div>
  );

  return (
    <>
      <DataTable
        ref={dataTableRef}
        showAddButton={ability.can(Action.Add, Page.O365CopilotChatUsage)}
        setSelectedId={setSelectedId}
        tableAction={tableAction}
        exportExcelFile={exportExcelFile}
        getTableColumns={getTableColumns}
        reduxSelector={o365CopilotChatUsageSelector}
        searchTableData={searchO365CopilotChatUsage}
        clearTableDataMessages={clearO365CopilotChatUsageMessages}
        setTableColumnSelection={setTableColumnSelection}
        setShowSelectedListModal={setShowSelectedListModal}
        setValuesForSelection={setValuesForSelection}
        showBulkUpdate={ability.can(Action.Update, Page.O365CopilotChatUsage)}
        setObjectForColumnFilter={setObjectForColumnFilter}
        tableButtons={tableButtons}
      />
    </>
  );
};

export default forwardRef(MainTable);
